import { createElement as rc } from 'react';
import { h2, Card, styled, fromTheme, View, Text, Button } from 'lib_ui-primitives';
import { session } from 'lib_ui-services';
import { CardBox } from './styles';
import Logo from '../Logo';
import useActiveRecord from '../../hooks/useActiveRecord';
import useEventSink from '../../hooks/useEventSink';

const Centered = styled(View).attrs({ name: 'centered' })`
    min-height: ${fromTheme('height')};
    width: 100%;
    height: 100%;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Main = styled(View).attrs({ name: 'main' })`
    flex-direction: column;
    justify-content: center;
    flex-grow: 0;
    max-width: 370px;
`;

const HeaderText = styled(h2)`
    color: ${fromTheme('card', 'header', 'textColor')};
    margin: ${({ theme }) => (theme.mobile ? '0px' : theme.viewMarginMore + 'px')};
    padding: ${fromTheme('viewPadding')};
    text-align: center;
`;

const ExplanationText = styled(Text).attrs({ name: 'explanation-text' })`
    margin: ${fromTheme('textMargin')};
    text-align: center;
    margin-bottom: 24px;
    color: ${fromTheme('errorColor')};
`;

const ButtonContainer = styled(View)`
    flex-direction: row;
    justify-content: center;
    margin-top: ${fromTheme('viewMargin')};
`;

const StickyFooter = styled(View).attrs({ name: 'stickyFooter' })`
    justify-content: center;
    padding: 12px 0px;
    flex-grow: 0;
    flex-basis: auto;
    flex-shrink: 0;
`;

const _p = { logout: session.logout };
export const _private = _p;

export default function VerifyAccountPage() {
    const [, publish] = useEventSink();
    const { namespace, relation, record, type } = useActiveRecord();

    // Clear the session data and send the user back to the login page if they click the "Back to Login" button
    const handleGoBack = () => {
        publish({}, { verb: 'remove', namespace, relation });
        _p.logout();
    };

    // Create a password change ticket via Auth0 and redirect the user to the Auth0 set password page
    const handleCreatePasswordChangeTicket = () => {
        publish({ record }, { verb: 'create', namespace, relation, type });
    };

    // prettier-ignore
    return rc(Centered, null,
        rc(Main, null,
            rc(CardBox, null,
                rc(Card.Header, { style: { justifyContent: 'center' } },
                    rc(HeaderText, { name: 'card-header-title', style: { margin: 0 } }, 'Account Verified')
                ),
                rc(Card.Body, null,
                    rc(ExplanationText, { style: { color: fromTheme('textColor'), marginBottom: '16px' } },
                        'Your account has been successfully verified. Finish setting up your account by setting a password.'
                    ),
                    rc(ButtonContainer, null,
                        rc(Button, {
                            value: 'Back to Login',
                            buttonStyle: 'primary',
                            onClick: handleGoBack
                        }),
                        rc(Button, {
                            value: 'Set Password',
                            buttonStyle: 'success',
                            onClick: handleCreatePasswordChangeTicket
                        })
                    )
                )
            )
        ),
        rc(StickyFooter, null, rc(Logo))
    );
}
